/* Accessibility helpers for Flickity sliders (testimonials, featured products).
   - Marks off-screen slides aria-hidden and removes their links from the tab order.
   - Wires the "Pause testimonials" button (data-slideshow-pause) to Flickity's player.
   Loaded independently of sections(.min).js so it works whether or not minify is on. */
(function () {
  'use strict';

  function syncSlides(flkty) {
    if (!flkty || !flkty.cells) return;
    flkty.cells.forEach(function (cell, i) {
      var active = i === flkty.selectedIndex;
      cell.element.setAttribute('aria-hidden', active ? 'false' : 'true');
      cell.element.removeAttribute('aria-selected'); // Flickity adds it, but it is not valid on a plain div
      var focusables = cell.element.querySelectorAll('a, button, [tabindex]');
      Array.prototype.forEach.call(focusables, function (el) {
        el.setAttribute('tabindex', active ? '0' : '-1');
      });
    });
  }

  function enhance(el) {
    if (el.dataset.adaEnhanced || !window.jQuery) return;
    var $el = window.jQuery(el);
    var flkty = $el.data('flickity');
    if (!flkty) return;
    el.dataset.adaEnhanced = '1';

    syncSlides(flkty);
    $el.on('select.flickity', function () { syncSlides($el.data('flickity')); });

    var btn = el.id && document.querySelector('[data-slideshow-pause="' + el.id + '"]');
    if (btn) {
      btn.addEventListener('click', function () {
        var f = $el.data('flickity');
        if (!f) return;
        var paused = btn.getAttribute('aria-pressed') === 'true';
        var label = paused ? 'Pause testimonials' : 'Play testimonials';
        if (paused) { f.playPlayer(); } else { f.stopPlayer(); }
        btn.setAttribute('aria-pressed', String(!paused));
        btn.setAttribute('aria-label', label);
        btn.setAttribute('title', label);
      });
    }
  }

  function stripAriaSelected() {
    var cells = document.querySelectorAll('.flickity-enabled .gallery-cell[aria-selected], .flickity-enabled .flickity-slider > [aria-selected]');
    Array.prototype.forEach.call(cells, function (c) { c.removeAttribute('aria-selected'); });
  }

  function scan() {
    stripAriaSelected();
    var nodes = document.querySelectorAll('.js-testimonial.flickity-enabled, .js-product-slider .products-slider.flickity-enabled');
    Array.prototype.forEach.call(nodes, enhance);
  }

  function start() {
    scan();
    // Sliders initialise after deferred bundles run; keep checking briefly, then watch the DOM.
    var tries = 0;
    var timer = setInterval(function () {
      scan();
      if (++tries > 40) clearInterval(timer); // ~10s
    }, 250);
    if (window.MutationObserver) {
      new MutationObserver(scan).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-selected'] });
    }
    document.addEventListener('shopify:section:load', scan);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
